export default "__VITE_ASSET__a8ccadf7__"